var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#C1BDB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 12.5998C18.9903 12.5998 19.8003 13.4098 19.8003 14.3998C19.8003 15.3898 18.9903 16.1998 18.0003 16.1998C17.0103 16.1998 16.2003 15.3898 16.2003 14.3998C16.2003 13.4098 17.0103 12.5998 18.0003 12.5998ZM18.0003 21.5998C20.4303 21.5998 23.2203 22.7608 23.4003 23.3998H12.6003C12.8073 22.7518 15.5793 21.5998 18.0003 21.5998ZM18.0003 10.7998C16.0113 10.7998 14.4003 12.4108 14.4003 14.3998C14.4003 16.3888 16.0113 17.9998 18.0003 17.9998C19.9893 17.9998 21.6003 16.3888 21.6003 14.3998C21.6003 12.4108 19.9893 10.7998 18.0003 10.7998ZM18.0003 19.7998C15.5973 19.7998 10.8003 21.0058 10.8003 23.3998V25.1998H25.2003V23.3998C25.2003 21.0058 20.4033 19.7998 18.0003 19.7998Z",
    fill: "white"
  })));
};
export default SvgUserIcon;